export const L10N = {
  LABEL_ALIPAY: { id: 'core.label.alipay' },
  LABEL_APLAZAME: { id: 'core.label.aplazame' },
  LABEL_BIZUM: { id: 'core.label.bizum' },
  LABEL_CARD: { id: 'core.label.card' },
  LABEL_CARD_PREPAY: { id: 'core.label.card' },
  LABEL_CRIPTAN: { id: 'core.label.criptan' },
  LABEL_IDEAL: { id: 'core.label.ideal' },
  LABEL_OXXO: { id: 'core.label.oxxo' },
  LABEL_PAYLATER: { id: 'core.label.pay_later' },
  LABEL_PAYMENT_METHODS: { id: 'core.label.payment_methods' },
  LABEL_PAYPAL: { id: 'core.label.paypal' },
  LABEL_PCIPROXY: { id: 'core.label.card' },
  LABEL_SCALAPAY: { id: 'core.label.scalapay' },
  LABEL_SOFORT: { id: 'core.label.sofort' },
  LABEL_TPV: { id: 'core.label.tpv' },
  LABEL_TRANSFER: { id: 'core.label.transfer' },
  LABEL_WECHATPAY: { id: 'core.label.wechat' },

  LABEL_CAPTION_DEFERRED: { id: 'core.label.caption_deferred' },
  LABEL_CAPTION_PAYLATER: { id: 'core.label.caption_pay_later' },
  LABEL_REDIRECT_APLAZAME: { id: 'core.label.redirect_aplazame' },
  LABEL_REDIRECT_CARD_PREPAYMENT: { id: 'core.label.redirect_card_prepayment' },
  LABEL_REDIRECT_CARDNET: { id: 'core.label.redirect_cardnet' },
  LABEL_REDIRECT_MORE_INFO: { id: 'core.label.redirect_more_info' },
  LABEL_REDIRECT: { id: 'core.label.redirect' },

  LABEL_DAY: { id: 'common.label.day' },
  LABEL_HOUR: { id: 'common.label.hour' },
};
